import { PresenceStatusTypes } from '../live-comm/presence';

export interface IAdminPresenceItem  {
    AdminID: number;
    FirstName: string;
    LastName: string;
    PresenceStatus: PresenceStatusTypes;
    Email: string;

}

export class AdminPresenceItemArray extends Array<AdminPresenceItem>  {

    constructor(...items: AdminPresenceItem[]) {
        super(...items);
        Object.setPrototypeOf(this, AdminPresenceItemArray.prototype);
    }

}

export class AdminPresenceItem  implements IAdminPresenceItem {
    AdminID: number;
    FirstName: string;
    LastName: string;
    Email: string;
    PresenceStatus: PresenceStatusTypes = PresenceStatusTypes.Unknown;

    public FullName(): string {
        return this.LastName == undefined ? this.FirstName : this.FirstName + ' ' + this.LastName;
    }

}
